import React from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import PropTypes from "prop-types";

function GuidanceBubble({ visible, message }) {
    if (!visible) return null;

    return (
        <MDBox
            position="absolute"
            top="-64px" // Accommodate arrow and bobbing
            left="50%"
            sx={{
                transform: "translateX(-50%)",
                width: "max-content",
                animation: "bob 2s infinite ease-in-out",
                zIndex: 1400,
            }}
        >
            <style>
                {`
            @keyframes bob {
              0%, 100% { transform: translateX(-50%) translateY(0); }
              50% { transform: translateX(-50%) translateY(-10px); }
            }
          `}
            </style>
            <MDBox
                variant="gradient"
                bgColor="dark"
                borderRadius="lg"
                coloredShadow="dark"
                px={2}
                py={1}
                position="relative"
                display="flex"
                alignItems="center"
                gap={1}
            >
                <MDBox
                    width="24px"
                    height="24px"
                    borderRadius="50%"
                    bgColor="accent" // Orange
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    opacity={1}
                >
                    <TouchAppIcon fontSize="small" sx={{ color: "black !important", fontSize: "16px !important", transform: "rotate(180deg)" }} />
                </MDBox>
                <MDTypography variant="caption" color="white" fontWeight="bold">
                    {message}
                </MDTypography>
                {/* Speech Bubble Arrow */}
                <MDBox
                    position="absolute"
                    bottom="-6px"
                    left="50%"
                    sx={{
                        width: 0,
                        height: 0,
                        borderLeft: "8px solid transparent",
                        borderRight: "8px solid transparent",
                        borderTop: "8px solid #191919", // Matches the bottom of dark gradient
                        transform: "translateX(-50%)",
                    }}
                />
            </MDBox>
        </MDBox>
    );
}

GuidanceBubble.propTypes = {
    visible: PropTypes.bool.isRequired,
    message: PropTypes.string.isRequired,
};

export default GuidanceBubble;
